import formatCurrency from '../../Util/Util';
import "./ModalCard.css"
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import React, { useContext } from 'react'
import { DataContext } from '../../../components/Context/Context'


function ModalCard(product) {
    const value = useContext(DataContext);
    const addCart = value.addCart;

    return (
        <>
            <p className='text-center modalCard' data-bs-toggle="modal" data-bs-target={`#${product._id}Modal`}> جزئیات</p>
            <div className="modal fade detailsModal" tabIndex="-1" id={`${product._id}Modal`} role="dialog" >
                <div className="modal-dialog rounded p-2" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">{product.name}</h6>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" >
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body row d-flex justify-content-center p-0 m-0 py-2">
                            <h6 className=''>{product.fullName}</h6>
                            <div className="row bg-white rounded cart-detail justify-content-center">
                                <div className="img-container col-10">
                                    <Swiper
                                        spaceBetween={10}
                                        navigation={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper2 rounded w-100"
                                    >
                                        {
                                            product.images.map(image => (
                                                <SwiperSlide  key={product._id}>
                                                    <img src={image} key={image} className='img-fluid w-100 h-100 rounded border p-4 bg-white' />
                                                </SwiperSlide>
                                            ))
                                        }
                                    </Swiper>
                                </div>
                                <div className="col-12 box-cart-details text-center">
                                    <div>
                                        <h6 className='py-4 nameProduct '>{product.fullName}</h6>
                                        <p>{product.content}</p>
                                    </div>

                                    <h5 className='price-cart'>{formatCurrency(product.price)}</h5>
                                    <button type="button" rel="tooltip" className="btn btn-warning p-2 border-0 mt-3" onClick={() => addCart(product._id)}>
                                        <span className='fs14'>افزودن به سبد خرید</span>
                                        <i className="bi bi-cart-check-fill ps-3 h5"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary fs12" data-bs-dismiss={"modal"}>بستن</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ModalCard